// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import PropTypes from 'prop-types'
import { Box } from 'grommet'
import { Trans, useTranslation } from 'react-i18next'

import { Notification, Typography } from '../../../../components'

const OneRoleAppWarningNotification = ({ state, serviceName, subject }) => {
  const { t } = useTranslation(['iam'])
  return (
    <Box pad={{ top: 'small' }}>
      <Notification
        type="inline"
        text={
          <Typography type="text" size="medium">
            <Trans
              i18nKey={
                state?.subjectType?.value === 'USER' || subject?.type === 'USER'
                  ? 'iam:msp.msp_one_scope_inline_notification_warning'
                  : 'iam:assign_roles_side_panel.role_assigned_on_subject'
              }
              values={{
                serviceName
              }}
              t={t}
            />
          </Typography>
        }
        status="critical"
        testId="one-role-app-warning"
      />
    </Box>
  )
}

OneRoleAppWarningNotification.propTypes = {
  state: PropTypes.object,
  serviceName: PropTypes.string,
  subject: PropTypes.string
}

export default OneRoleAppWarningNotification
